/*globals $ */

class BackgroundImg {
  constructor($container) {
    this.$window = $(window);

    this.$container = $container;
    this.$bgInner = this.$container.find(".sec_rc_bg_inner");
    this.repeatMinHeight = 334 - 50;
    this.repeatNumY = 0;

    this.text = "test message";
    this.$contents = this.$container.find(".sec_rc_content");
    this.$contentsBody = this.$container.find(".sec_rc_content_area");
    this.mtest = this.onWindowResize();

    this.$window.on("resize", () => {
      this.onWindowResize();
    });
    this.onWindowResize();
  }

  onWindowResize() {
    var windowWidth = $(window).width();

    this.contentsHeight = this.$contentsBody.outerHeight();
    for (var i = 0; i < 10; i++) {
      if (this.repeatMinHeight * i > this.contentsHeight) {
        this.repeatNumY = i;
        break;
      }
    }

    this.$bgInner.width(windowWidth);
    this.$bgInner.css({
      left: -(Math.floor(windowWidth / 2) + 1),
      height: this.repeatMinHeight * this.repeatNumY + 50,
    });

    this.fixBgDom();
  }

  fixBgDom() {
    this.$container.height(this.repeatMinHeight * this.repeatNumY + 50);
    this.$container.css("overflow", "hidden");
    this.$bgInner.empty();

    for (var i = 0; i < this.repeatNumY; i++) {
      this.$bgInner.append('<div class="sec_rc_bg_inner_block"></div>');
    }
  }
}

export default BackgroundImg;
